export default "__VITE_PUBLIC_ASSET__ff3cf5c0__"